<template>
  <div>
    <div v-if="!questionAnswered">
      <div class="mt-6 py-5 text-left">
        <!-- <p class="text-sm mb-2">Frage {{ question.prio }} von 6</p> -->
        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      

      <form @submit.prevent="submit" novalidate class="mt-3 text-center">
        <div class="flex items-center justify-center">
          <div class="w-fit">
            <div class="flex items-center justify-center space-x-1 sm:space-x-4">
              <button type="button" :disabled="sending" v-for="num in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="num"
                @click="select(num)" class="
                  flex
                  items-center
                  justify-center
                  shrink-0
                  w-7
                  h-7
                  sm:w-12 sm:h-12
                  rounded-full
                  border border-transparent
                  
                  
                  focus:outline-none
                  focus:ring-2
                  focus:ring-markencode-blue
                  focus:ring-offset-2
                  text-md
                  sm:text-2xl
                  
                " :class="[
                  form.answer == num
                    ? 'bg-markencode-blue text-white'
                    : 'bg-gray-300 text-gray-500',
                  sending ? '' : 'hover:bg-markencode-blue hover:text-white',
                ]">
                {{ num }}
              </button>
            </div>

            <div v-if="question.prio == 2" class="mt-4 flex items-center justify-between">
              <div>Doch</div>
              <div>Stimmt</div>
            </div>

            <div v-if="question.prio != 2" class="mt-4 flex items-center justify-between">
              <div>Nein</div>
              <div>Ja</div>
            </div>
          </div>
        </div>


        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-16">{{
          translations.save }}</submit-button>
      </form>
    </div>


    <div v-if="questionAnswered && session.show_live_results" class="mt-12 sm:mt-6 px-4 py-5 text-center">
      <h1 class="text-3xl sm:text-4xl font-extralight mb-3">
        {{ translations.thank_you }}
      </h1>
      <p class="font-extralight">Und das sagt die Gruppe:</p>

      <rating :session="session" :translations="translations"></rating>

      <div class="text-left mt-16 px-16">
        <div class="border-t border-gray-400 mb-4"></div>
        <p>Frage: </p>
        <p class="font-extralight">{{ generatedQuestion }}</p>
      </div>
    </div>

    <div v-if="questionAnswered && !session.show_live_results" class="mt-6 px-8 py-5 text-left">
      <h1 class="text-3xl sm:text-4xl font-extralight mb-3">
        {{ translations.thank_you }}
      </h1>
    </div>

  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import Rating from '@/Pages/LiveResults/Rating';
import { throttle } from 'lodash';

export default {
  components: {
    SubmitButton,
    Rating,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        answer: '',
      },
    };
  },

  methods: {
    select(num) {
      this.form.answer = num;
    },

    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('live.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    validated() {
      return this.form.answer > 0;
    },
    questionAnswered() {
      return this.answerParameters || this.answered;
    },
    channel() {
      return Echo.channel(
        'markencode-app.session.' + this.participant.markencode_session.id
      );
    },


  },

  created() {
    // this.channel.here((users) => {
    //     console.log(users);
    // })
  },

  destroyed() {
    // console.log('leaving rating component');
    // this.channel.leave('markencode-app.session.' + this.participant.markencode_session.id);
  },

  // watch: {
  //   form: {
  //     handler: throttle(function() {
  //       this.channel.whisper(
  //         'participant.busy',
  //         {
  //           participant_id: this.participant.id
  //         }
  //       );
  //     }, 2000),
  //     deep: true
  //   }
  // }
};
</script>